import EmailInput from './EmailInput'
import fillEmailInput from './testHelper/fillEmailInput'
import expectEmailInputValue from './testHelper/expectEmailInputValue'

export default EmailInput

export { expectEmailInputValue, fillEmailInput }
